import { PermissionGrant } from "@herbjoy/apex-api-models";

interface PermissionAggregate {
    found: boolean;
    disabled: boolean;
}

/**
 * A filter used to simplify checking if permission is granted in the UI.
 */
export function PermissionGrantFilter() {
    /**
     * @param grants The list of permissions granted.
     * @param permissionKey The permission to be checked.
     */
    return function filter(grants: PermissionGrant[], permissionKey: string): boolean {
        if (!grants || !grants.reduceRight) {
            console.warn("Left hand argument 'grants' is invalid for PermissionGrantFilter. Expected an array, got ", grants)
            return false;
        }
        if (!permissionKey) {
            console.error("A permission key is required when using PermissionGrantFilter",
                "Usage: permissionGrants | permission : 'permissionName'");
            return false;
        }
        const {found, disabled } = grants.reduceRight(({ found, disabled }: PermissionAggregate, grant) => {
            return {
                found: found || grant.Description.Key === permissionKey,
                disabled: disabled || grant.Description.Key === permissionKey
                    && grant.Value !== "true"
            }
        }, { found: false, disabled: false });
        return found && !disabled;
    }
}
